import generate from "./generator.js";

document.addEventListener("DOMContentLoaded", () => {
  generate();
});
